const bookShopPhoneNumber = (state = "", action) => {
    switch(action.type) {
        case 'bookShopPhoneNumber':
            return action.payload;
        default:
            return state;
    }
}

export default bookShopPhoneNumber;